import { ApiPagedResult, BaseService } from "@k-digitale/kappa";
import { CourseInstanceFinder, CourseParticipationOutcomeFinder } from "@/learning/instances/Models";
import { CourseInstanceWrapper, CourseParticipationOutcomeWrapper } from "./Models";

class LearningWrappersServices extends BaseService {

    async getCourseParticipationOutcomesWrappersByFinder(finder: CourseParticipationOutcomeFinder): Promise<ApiPagedResult<CourseParticipationOutcomeWrapper>> {
        const response = await this.tryExecute(
            this.api.get<any>("cesf/learning-wrappers/course-participation-outcomes/", { params: finder })
        );

        return response!.data;
    }
    async getCourseParticipationOutcomesWrappersForActualCompanyStudents(companyId: string, finder: CourseParticipationOutcomeFinder): Promise<ApiPagedResult<CourseParticipationOutcomeWrapper>> {
        const response = await this.tryExecute(
            this.api.get<any>(`cesf/learning-wrappers/companies/${companyId}/course-participation-outcomes/`, { params: finder })
        );

        return response!.data;
    }

    async getCourseInstancesWrappersByFinder(finder: CourseInstanceFinder): Promise<ApiPagedResult<CourseInstanceWrapper>> {
        const response = await this.tryExecute(
            this.api.get<any>("cesf/learning-wrappers/course-instances/", { params: finder })
        );

        return response!.data;
    }

}

export const learningWrappersService = new LearningWrappersServices();
